var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBaintexLogoHWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_baintex",
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.155,
    height: 26.923,
    viewBox: "0 0 159.155 26.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_172",
    "data-name": "Trazado 172",
    d: "M3466.64,813.722a5.283,5.283,0,0,1-3.115-.989c-.941-.632-1.891-1.248-2.846-1.859a7.786,7.786,0,0,0-1.567-.8,2.594,2.594,0,0,0-1.878.052,10.21,10.21,0,0,0-1.8.982c-.947.617-1.89,1.243-2.838,1.856a4.772,4.772,0,0,1-1.906.709,5.064,5.064,0,0,1-3.776-.87,5.122,5.122,0,0,1-2.139-4.235,5.237,5.237,0,0,1,.878-2.814c.749-1.144,1.5-2.292,2.228-3.448a4.956,4.956,0,0,0,.635-1.431,2.622,2.622,0,0,0-.141-1.648,10.872,10.872,0,0,0-1.028-1.86c-.6-.93-1.216-1.852-1.817-2.784a4.716,4.716,0,0,1-.7-1.948,5.038,5.038,0,0,1,.868-3.656,4.955,4.955,0,0,1,2.385-1.842,5.163,5.163,0,0,1,4.7.569q1.538,1.017,3.091,2.014a6.588,6.588,0,0,0,1.477.748,2.581,2.581,0,0,0,1.012.162,2.909,2.909,0,0,0,1.188-.338c.634-.353,1.265-.716,1.879-1.1.9-.562,1.767-1.164,2.666-1.724a4.154,4.154,0,0,1,1.735-.589,6.371,6.371,0,0,1,1.178-.046,4.91,4.91,0,0,1,2.719,1.04,4.964,4.964,0,0,1,1.911,3.253,5.081,5.081,0,0,1-.816,3.669c-.623.944-1.247,1.888-1.858,2.838a9.876,9.876,0,0,0-.883,1.652,2.639,2.639,0,0,0,.14,2.3c.319.615.675,1.211,1.044,1.8.557.883,1.147,1.747,1.7,2.631a4.415,4.415,0,0,1,.652,1.8,5.959,5.959,0,0,1,.072.989,5.07,5.07,0,0,1-3.846,4.78A4.386,4.386,0,0,1,3466.64,813.722Zm-8.414-15.046c-.2-.2-4.469-4.508-6.675-6.713a1.128,1.128,0,0,0-1.1-.342,1.143,1.143,0,0,0-.6,1.881c.11.125.236.238.354.357q1.621,1.62,3.242,3.24c1.021,1.02,3.057,3.042,3.178,3.164-2.191,2.189-4.491,4.492-6.682,6.68a1.162,1.162,0,0,0-.368,1.038,1.14,1.14,0,0,0,1.935.63c2.2-2.195,6.67-6.684,6.712-6.734.052.05,1.176,1.172,1.712,1.709l2.543,2.549c.8.8,1.607,1.6,2.4,2.405a1.178,1.178,0,0,0,1.027.4,1.084,1.084,0,0,0,.95-.793,1.1,1.1,0,0,0-.294-1.164q-2.843-2.847-5.687-5.687l-1.036-1.033c.038-.033,4.508-4.492,6.714-6.7a1.112,1.112,0,0,0,.345-.945,1.083,1.083,0,0,0-.757-.959,1.051,1.051,0,0,0-1.163.254q-2.793,2.775-5.572,5.566C3459.024,797.869,3458.652,798.245,3458.226,798.676Z",
    transform: "translate(-3444.774 -786.81)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(38.805 7.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_173",
    "data-name": "Trazado 173",
    d: "M3563.629,812.48a4.235,4.235,0,0,1,1.42,1.207,2.792,2.792,0,0,1,.5,1.669,3.138,3.138,0,0,1-.325,1.421,3.326,3.326,0,0,1-.933,1.13,4.461,4.461,0,0,1-1.472.744,6.659,6.659,0,0,1-1.959.265h-10.8V806.524h10.457a5.079,5.079,0,0,1,1.994.393,4.3,4.3,0,0,1,1.549,1.078,3.044,3.044,0,0,1,.838,2.1,2.8,2.8,0,0,1-.308,1.344A3.089,3.089,0,0,1,3563.629,812.48Zm-3.013-1.129a1.211,1.211,0,0,0,.864-.351,1.184,1.184,0,0,0,.368-.9,1.105,1.105,0,0,0-.376-.864,1.42,1.42,0,0,0-.976-.333h-7.428v2.447Zm0,5.186a2.316,2.316,0,0,0,1.4-.351,1.156,1.156,0,0,0,.471-.984,1.332,1.332,0,0,0-.479-1.061,1.986,1.986,0,0,0-1.334-.411h-7.6v2.807Z",
    transform: "translate(-3550.057 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_174",
    "data-name": "Trazado 174",
    d: "M3613.941,818.915l-1.42-2.67h-7.941l-1.421,2.67h-3.046l6.589-12.391h3.714l6.572,12.391Zm-5.408-10.132-2.721,5.083h5.442Z",
    transform: "translate(-3581.662 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_175",
    "data-name": "Trazado 175",
    d: "M3655.924,818.915V806.524h3.012v12.391Z",
    transform: "translate(-3616.903 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_176",
    "data-name": "Trazado 176",
    d: "M3690.979,818.915l-8.4-8.848h-.051v8.848h-3.012V806.524h3.508l8.4,8.865h.069v-8.865h3.012v12.391Z",
    transform: "translate(-3631.797 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M3740.526,808.9v10.012h-3.012V808.9h-5.9v-2.379h14.822V808.9Z",
    transform: "translate(-3664.691 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M3783.243,818.915V806.524h13.436V808.9h-10.423v2.533h7.24v2.379h-7.24v2.721h10.9v2.379Z",
    transform: "translate(-3697.293 -806.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M3842.4,818.915l-4.775-4.467-4.826,4.467h-4l6.778-6.281-6.555-6.11h4l4.57,4.3,4.587-4.3h4l-6.554,6.11,6.777,6.281Z",
    transform: "translate(-3726.055 -806.524)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaintexLogoHWhite);
export default __webpack_public_path__ + "static/media/icon_baintex_logo_h_white.9a501d1460cb032960960ba4ec7d9ca5.svg";
export { ForwardRef as ReactComponent };